import { useState, useRef } from 'react';
import Slider from 'rc-slider';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faMinus } from '@fortawesome/pro-regular-svg-icons';
import { ClientInput } from "../inputs/ClientInput";
import { onClickOutside } from "../../lib/customHooks/onClickOutside";
import { preventDot, validateMinRange, validateMaxRange } from "../../lib/utils";
import { getValue } from "../../lib/fields/Number";
import { withDependentReferenceData } from "../../lib/customHooks/useReferenceData";
const NumberPreview = withDependentReferenceData(({
  update,
  value,
  required,
  read_only,
  mask,
  label,
  errors,
  id,
  onBlur
}) => {
  const isDecimalAllowed = `${mask}` != `0`;
  const handleOnKeyPress = e => {
    if (isDecimalAllowed) {
      return () => {};
    } else {
      return preventDot(e);
    }
  };
  const numberProps = {
    value: value,
    update,
    readOnly: read_only,
    label: `${required ? `${label}*` : label}`,
    id,
    errorText: errors,
    disabled: read_only,
    type: 'number',
    onKeyPress: e => handleOnKeyPress(e),
    onBlur: onBlur,
    onWheel: e => e.target.blur(),
    step: 'any',
    error: errors
  };
  return <ClientInput {...numberProps} />;
});
const CurrencyPreview = withDependentReferenceData(({
  update,
  value,
  required,
  read_only,
  label,
  id,
  errors,
  onBlur
}) => {
  const updateNumber = input => {
    const strippedInput = input.replace(/[^\d\.]/g, '');
    update(strippedInput);
  };
  const numberProps = {
    value: value,
    update: updateNumber,
    readOnly: read_only,
    label: `${required ? `${label}*` : label}`,
    id,
    disabled: read_only,
    errorText: errors,
    step: 'any',
    onBlur: onBlur,
    error: errors
  };
  return <ClientInput {...numberProps} />;
});
const IncrementPreview = withDependentReferenceData(({
  update,
  minimum,
  maximum,
  value,
  read_only,
  label,
  id,
  required,
  errors,
  onBlur
}) => {
  const inputRef = useRef(null);
  const [active, setActiveState] = useState(false);
  const incrementValue = () => {
    setActiveState(true);
    const newValue = Number(value) + 1;
    const meetsMaximum = validateMaxRange(maximum, newValue);
    meetsMaximum ? updateValue(newValue) : '';
  };
  const decrementValue = () => {
    setActiveState(true);
    const newValue = Number(value) - 1;
    const meetsMinimum = validateMinRange(minimum, newValue);
    meetsMinimum ? updateValue(newValue) : '';
  };
  const updateValue = value => {
    if (read_only) {
      return;
    }
    update(value);
  };
  onClickOutside(inputRef, () => {
    setActiveState(false);
  });
  return <div className="increment input--placeholder" ref={inputRef} onClick={() => !read_only && setActiveState(true)}>
        <div className={`plus--minus-container ${active ? 'focused' : ''} ${read_only ? 'disabled' : ''} ${errors ? 'error' : ''}`}>
          <div className={`increment--control minus ${active ? 'focus' : ''} `} onClick={decrementValue}>
            <FontAwesomeIcon icon={faMinus} className="icon--decrement" />
          </div>
          <div className={`increment--control plus ${active ? 'focus' : ''} `} onClick={incrementValue}>
            <FontAwesomeIcon icon={faPlus} className="icon--increment" />
          </div>
        </div>

        <ClientInput value={value} type="number" update={update} additionalClass={`${active ? 'increment--input-focus' : ''}`} readOnly={read_only} id={id} disabled={read_only} errorText={errors} error={errors} label={`${required ? `${label}*` : label}`} onBlur={onBlur} onWheel={e => e.target.blur()} onKeyPress={preventDot} />
      </div>;
});
const SliderPreview = withDependentReferenceData(({
  update,
  minimum: fieldMinimum,
  maximum: fieldMaximum,
  value,
  label,
  read_only
}) => {
  const minimum = fieldMinimum || 0;
  const maximum = fieldMaximum || 10;
  return <div className={`${read_only ? 'slider--disabled' : ''} input--slider`}>
        <div className="foundry--input-fields user-form--input slider--info">
          <div className="slider--value">{value}</div>
          <label className="input-fields__label">{label}</label>
        </div>
        <Slider min={parseInt(minimum)} max={parseInt(maximum)} step={1} value={parseInt(value)} onChange={update} disabled={read_only} className={`slider ${read_only ? 'slider-disabled' : ''}`} />
        <div className="slider--range">
          <div className="range--min">{minimum}</div>
          <div className="slider--max">{maximum}</div>
        </div>
      </div>;
});
const getNumberFieldComponent = ({
  style
}) => {
  switch (`${style}`) {
    case '0':
      return NumberPreview;
    case '1':
      return IncrementPreview;
    case '2':
      return SliderPreview;
    case '4':
      return CurrencyPreview;
    default:
      return NumberPreview;
  }
};
export const NumberFieldsPreview = previewEntry => {
  const NumberField = getNumberFieldComponent(previewEntry);
  const numberValue = getValue(previewEntry);
  return <NumberField {...previewEntry} value={numberValue} />;
};